var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle */
import React from 'react';
import styled from 'styled-components';
import cuid from 'cuid';
import useConfig from '../../hooks/useConfig';
import filterTimeControl from '../../../utils/filterTimeControl';
import ComponentRecognizer from '../../ComponentRecognizer';
var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: stretch;\n  height: 100%;\n  margin: 0;\n\n  flex-direction: ", ";\n\n  padding: ", ";\n\n  .component-recognizer-container[type='image_footer'] {\n    max-width: ", ";\n  }\n\n  @media only screen and (max-width: ", ") {\n    > div {\n      ", "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    flex-direction: ", ";\n\n    > div {\n      ", "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: stretch;\n  height: 100%;\n  margin: 0;\n\n  flex-direction: ",
    ";\n\n  padding: ", ";\n\n  .component-recognizer-container[type='image_footer'] {\n    max-width: ", ";\n  }\n\n  @media only screen and (max-width: ", ") {\n    > div {\n      ",
    "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    flex-direction: ",
    ";\n\n    > div {\n      ",
    "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n"])), function (_a) {
    var cellsPerRowPercentageMobile = _a.cellsPerRowPercentageMobile;
    return cellsPerRowPercentageMobile === 100 ? 'column' : 'row';
}, function (_a) {
    var padding = _a.padding;
    return padding;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth;
}, function (_a) {
    var mobileMaxWidth = _a.mobileMaxWidth;
    return mobileMaxWidth;
}, function (_a) {
    var cellsPerRowMobile = _a.cellsPerRowMobile, colGap = _a.colGap, rowGap = _a.rowGap;
    if (cellsPerRowMobile > 1) {
        if (colGap !== '0') {
            return "flex-basis: calc((100% - " + colGap + " * (" + cellsPerRowMobile + " - 1)) / " + cellsPerRowMobile + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
        }
        return "flex-basis: calc(100% / " + cellsPerRowMobile + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
    }
    if (cellsPerRowMobile === 1) {
        return "margin-bottom: " + rowGap + ";";
    }
    return null;
}, function (_a) {
    var cellsPerRowMobile = _a.cellsPerRowMobile;
    return cellsPerRowMobile;
}, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var cellsPerRowPercentage = _a.cellsPerRowPercentage;
    return cellsPerRowPercentage === 100 ? 'column' : 'row';
}, function (_a) {
    var cellsPerRowDesktop = _a.cellsPerRowDesktop, colGap = _a.colGap, rowGap = _a.rowGap;
    if (cellsPerRowDesktop > 1) {
        if (colGap !== '0') {
            return "flex-basis: calc((100% - " + colGap + " * (" + cellsPerRowDesktop + " - 1)) / " + cellsPerRowDesktop + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
        }
        return "flex-basis: calc(100% / " + cellsPerRowDesktop + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
    }
    return "margin-bottom: " + rowGap + ";";
}, function (_a) {
    var cellsPerRowDesktop = _a.cellsPerRowDesktop;
    return cellsPerRowDesktop;
});
var FooterGroupImage = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var contentData = _a.contentData, _h = _a.uuid, uuid = _h === void 0 ? cuid() : _h;
    var config = useConfig();
    var _j = contentData.field_cells_per_row, cellsPerRowDesktop = _j === void 0 ? contentData.paragraph
        ? contentData.paragraph.length
        : 0 : _j, _k = contentData.field_cells_per_row_mobile, cellsPerRowMobile = _k === void 0 ? Math.floor(cellsPerRowDesktop / 2) : _k, _l = contentData.field_col_gap, colGap = _l === void 0 ? '0' : _l, _m = contentData.field_row_gap, rowGap = _m === void 0 ? '0' : _m, _o = contentData.field_footer_layout_variant, layoutVariant = _o === void 0 ? 'default' : _o, _p = contentData.field_padding, padding = _p === void 0 ? '0' : _p, _q = contentData.field_max_width, maxWidth = _q === void 0 ? 'auto' : _q;
    var cellsPerRowPercentageMobile = 100 / cellsPerRowMobile;
    var cellsPerRowPercentage = 100 / cellsPerRowDesktop;
    var elements = [];
    (_c = (_b = contentData === null || contentData === void 0 ? void 0 : contentData.paragraph) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return filterTimeControl(item); })) === null || _c === void 0 ? void 0 : _c.forEach(function (item) {
        elements.push(React.createElement(ComponentRecognizer, { content: [item], key: cuid() }));
    });
    return (React.createElement(StyledWrapper, { key: "footer-group-image-" + uuid, cellsPerRowDesktop: cellsPerRowDesktop, cellsPerRowPercentage: cellsPerRowPercentage, cellsPerRowPercentageMobile: cellsPerRowPercentageMobile, cellsPerRowMobile: cellsPerRowMobile, colGap: colGap, rowGap: rowGap, layoutVariant: layoutVariant, padding: padding, maxWidth: maxWidth, mobileMaxWidth: (_e = (_d = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.mobileMaxWidth, tabletMinWidth: (_g = (_f = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g.tabletMinWidth }, elements));
};
export default FooterGroupImage;
var templateObject_1;
//# sourceMappingURL=index.js.map